<template>
  <div class="wapper" v-if="getData">
    <div class="box-content" >
      <label class="form-title">入学时间</label>
      <el-date-picker
        class='jm-input135'
        format="yyyy"
        value-format="yyyy"
        v-model.trim="getData.custom_year"
        type="year"
        placeholder="请选择"/>
      <el-date-picker
        class='jm-input135'
        format="MM"
        value-format="MM"
        :disabled="!getData['custom_year']"
        v-model="getData['custom_month']"
        type="month"
        style="margin:0"
        placeholder="请选择"/>
    </div>
    <div class="box-content2">
      <div>
        <div class="yuyan">
          <label class="form-title">IELTS</label>
          <el-input
            class="small"
            v-validate="{decimal: 1}"
            name="IELTSALL"
            v-model="getData.IELTS.ln_all"
            placeholder="总分"/>
        </div>
        <div class="yuyan">
          <label class="form-title">L</label>
          <el-input
            class="small"
            v-validate="{decimal: 1}"
            name="IELTSL"
            v-model="getData.IELTS.ln_listen"
            placeholder="L"/>
        </div>
        <div class="yuyan">
          <label class="form-title">R</label>
          <el-input
            class="small"
            v-validate="{decimal: 1}"
            name="IELTSR"
            v-model="getData.IELTS.ln_read"
            placeholder="R"/>
        </div>
        <div class="yuyan">
          <label class="form-title">S</label>
          <el-input
            class="small"
            v-validate="{decimal: 1}"
            name="IELTSS"
            v-model="getData.IELTS.ln_say"
            placeholder="S"/>
        </div>
        <div class="yuyan">
          <label class="form-title">W</label>
          <el-input
            class="small"
            v-validate="{decimal: 1}"
            name="IELTSW"
            v-model="getData.IELTS.ln_write"
            placeholder="W"/>
        </div>
        <div class="yuyan">
          <el-checkbox v-model="getData.isukvi">是否UKVI</el-checkbox>
        </div>
      </div>
      <span
        class="errors"
        v-if="errors.has('IELTSALL')" >*{{ errors.first('IELTSALL') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSL')" >*{{ errors.first('IELTSL') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSR')" >*{{ errors.first('IELTSR') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSS')" >*{{ errors.first('IELTSS') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSW')" >*{{ errors.first('IELTSW') }}</span>
    </div>
    <div class="box-content3">
      <div>
        <div class="yuyan">
          <label class="form-title">TOEFL</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="TOEFLAll"
            v-model="getData.TOEFL.ln_all"
            placeholder="总分"/>
        </div>
        <div class="yuyan">
          <label class="form-title">L</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="TOEFLL"
            v-model="getData.TOEFL.ln_listen"
            placeholder="L"/>
        </div>
        <div class="yuyan">
          <label class="form-title">R</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="TOEFLR"
            v-model="getData.TOEFL.ln_read"
            placeholder="R"/>
        </div>
        <div class="yuyan">
          <label class="form-title">W</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="TOEFLW"
            v-model="getData.TOEFL.ln_write"
            placeholder="W"/>
        </div>
        <div class="yuyan">
          <label class="form-title">S</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="TOEFLS"
            v-model="getData.TOEFL.ln_say"
            placeholder="S"/>
        </div>
      </div>
      <span
        class="errors"
        v-if="errors.has('TOEFLAll')" >*{{ errors.first('TOEFLAll') }}</span>
      <span
        class="errors"
        v-if="errors.has('TOEFLL')" >*{{ errors.first('TOEFLL') }}</span>
      <span
        class="errors"
        v-if="errors.has('TOEFLR')" >*{{ errors.first('TOEFLR') }}</span>
      <span
        class="errors"
        v-if="errors.has('TOEFLW')" >*{{ errors.first('TOEFLW') }}</span>
      <span
        class="errors"
        v-if="errors.has('TOEFLS')" >*{{ errors.first('TOEFLS') }}</span>
    </div>
    <div class="box-content3">
      <div>
        <div class="yuyan">
          <label class="form-title">GRE</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="GRE"
            v-model="getData.GRE.ln_all"
            placeholder="总分"/>
        </div>
        <div class="yuyan">
          <label class="form-title">数学</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="GRES"
            v-model="getData.GRE.ln_listen"
            placeholder="L"/>
        </div>
        <div class="yuyan">
          <label class="form-title">语文</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="GREY"
            v-model="getData.GRE.ln_read"
            placeholder="R"/>
        </div>
        <div class="yuyan">
          <label class="form-title">写作</label>
          <el-input
            class="small"
            v-validate="'numeric'"
            name="GREX"
            v-model="getData.GRE.ln_write"
            placeholder="W"/>
        </div>
      </div>
      <span
        class="errors"
        v-if="errors.has('GRE')" >*{{ errors.first('GRE') }}</span>
      <span
        class="errors"
        v-if="errors.has('GRES')" >*{{ errors.first('GRES') }}</span>
      <span
        class="errors"
        v-if="errors.has('GREY')" >*{{ errors.first('GREY') }}</span>
      <span
        class="errors"
        v-if="errors.has('GREX')" >*{{ errors.first('GREX') }}</span>
    </div>
    <div class="box-content-auto">
      <div class="yuyan">
        <label class="form-title">GMAT</label>
        <el-input
          class="small"
          v-validate="'numeric'"
          name="GMAT"
          v-model="getData.GMAT.ln_all"
          placeholder="总分"/>
      </div>
      <span
        class="errors"
        v-if="errors.has('GMAT')" >*{{ errors.first('GMAT') }}</span>
    </div>
    <div class="box-content-all">
      <label class="form-title">语言成绩备注（*）</label>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2}"
        placeholder="请输入内容"
        v-model="getData.other_languages_text"/>
    </div>
    <div class="box-content-all">
      <div class="email">
        <label class="form-title">申请邮箱（*）</label>
        <el-input
          v-model="getData.offer_email"
          placeholder="邮箱用户名"/>
        <el-input
          v-model="getData.offer_email_pass"
          placeholder="邮箱密码"/>
        <el-checkbox v-model="getData.offer_tell_student">是否告知学生</el-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from 'vee-validate';

export default {
  data() {
    return {
    };
  },
  props: {
    getData: {
      type: Object,
      default: null
    },
  },
  methods: {
    yanzhaqngAll() {
      // 本页验证信息方法
      const dictionary = {
        zh_CN: {
          messages: {
            required: (field) => { return `请输入${field}`; },
            between: (filed, data) => { return `${filed}应该在${data[0]} 到 ${data[1]}之间`; },
            numeric: (filed) => { return `${filed}只能为整数`; },
            decimal: (filed) => { return `${filed}最多一位小数`; }
          },
          attributes: {
            IELTSALL: '雅思成绩',
            IELTSL: '雅思听力成绩',
            IELTSR: '雅思阅读成绩',
            IELTSW: '雅思写作成绩',
            IELTSS: '雅思口语成绩',
            TOEFLAll: '托业成绩',
            TOEFLL: '托业听力成绩',
            TOEFLS: '托业口语成绩',
            TOEFLW: '托业写作成绩',
            TOEFLR: '托业阅读成绩',
            GRE: 'GRE成绩',
            GRES: 'GRE数学成绩',
            GREY: 'GRE语文成绩',
            GREX: 'GRE写作成绩',
            GMAT: 'GMAT成绩'
          }
        }
      };
      Validator.localize(dictionary);
    }
  },
  watch: {
  },
  components: {
    Validator
  },
  mounted() {
    this.yanzhaqngAll();
  }
};
</script>
<style scoped>
  .btn-group{
    padding: 10px;
    border: 1px solid #ebeef5;
    border-top: none;
    background: #FBFDFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-group a{
    line-height: 34px;
    display: block;
    float: left;
    height:34px;
    padding: 0 16px;
    font-size: 14px;
    border-radius: 4px;
    color: #409EFF;
    border: 1px solid #409EFF;
    margin-left: 8px;
  }
  .btn-group:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-auto:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-auto{
    display: flex;
    width: 20%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .errors{
    color: red;
  }
  .wapper:after,.box-content2:after,.yuyan:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-all{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .email{
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .yuyan{
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .yuyan .small{
    width: 60px;
  }
  .box-content{
    width: 30%;
    display: block;
    float: left;
    margin-bottom: 10px;
  }
  .box-content2{
    width: 70%;
    float: left;
    margin-bottom: 10px;
  }
  .box-content2>div{
    display: flex;
    align-items: center;
  }
  .box-content3{
    width: 40%;
    float: left;
    margin-bottom: 10px;
  }
  .box-content3>div{
    display: flex;
  }
  .form-title{
    margin-right: 6px;
    white-space: nowrap;
  }
  .basic-title{
    cursor: default;
    margin-left: 0;
  }
  .basic-title em{
    display: inline-block;
    width: auto!important;
    float: left;
    height: 31px;
    font-size: 16px;
    line-height: 28px;
    padding: 0 8px;
    border-bottom: 4px solid #3368fa;
  }

</style>
